/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-05-08 11:22:33
 * @LastEditors: changfeng
 * @LastEditTime: 2024-05-08 13:46:04
 */
export default {
	"optimizationEvent.SHOPPING": "支付完成",
	"optimizationEvent.ADD_BILLING": "添加支付信息",
	"optimizationEvent.INITIATE_ORDER": "开始结账",
	"optimizationEvent.ON_WEB_CART": "加入购物车",
	"optimizationEvent.ON_WEB_DETAIL": "查看内容",
	"optimizationEvent.ON_WEB_ADD_TO_WISHLIST": "加入心愿单",
	"optimizationEvent.BUTTON": "点击按钮",
	"optimizationEvent.ON_WEB_REGISTER": "完成注册",
	"optimizationEvent.CONTACT": "联系",
	"optimizationEvent.DOWNLOAD_START": "下载",
	"optimizationEvent.CONSULT": "咨询",
	"optimizationEvent.ON_WEN_ORDER": "下单",
	"optimizationEvent.ON_WEB_SEARCH": "搜索",
	"optimizationEvent.FORM": "提交表单",
	"optimizationEvent.ON_WEB_SUBSCRIBE": "订阅"
};
